module.exports = __webpack_public_path__ + "static/salaried-bed52dd04d46709138466d9386bff511.svg";